import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  menu: [],
  users: [],
  user: {},
  priorities: [],
  departments: [],
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  
  set (state, [variable, value]) {
    state[variable] = value
  },  

  setMenu (state, menu) {
    state.menu = menu
  },

  setUser (state, user) {
    state.user = user
  },  

  clearUser (state) {
   state.user = null;
  },

  setUsers (state, users) {
    state.users = users;
  },


}

const actions = {
  // Acción para cargar el menu y no tener que hacerlo desde el componente.
  loadMenu({commit}, menuData){
    commit('setMenu', menuData);
  },
  // loadUsers({commit}){
  //   return this._vm.$api.users.index().then(resp => commit('setUsers', resp.data.data));
  // },
  userLogin({commit}, user){
    commit('setUser', user)
  },

  
}

export default new Vuex.Store({
  state,
  mutations,
  actions
})